import { useEffect, useRef, useState } from "react";
import { useApiContext } from "context/ApiContext";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import TurbineDashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TurbineDashboardNavbar from "examples/Navbars/DashboardNavbar";

import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from "@mui/icons-material/Refresh";
import Hls from "hls.js";

function TurbineLiveCameraView() {
  const { APIRequestType, cameraStreamUrlTuL, getAPI, selectedCameraTuL, setCameraStreamUrlTuL, setSelectedCameraTuL, setStreamStateTuL,
    streamStateTuL, turbineTuL } = useApiContext();
  const [buttonColumnHeight, setButtonColumnHeight] = useState(0);
  const buttonColumnRef = useRef(null);

  const videoRef = useRef(null);

  useEffect(() => {
    setSelectedCameraTuL(1);
    setStreamStateTuL("LOADING");
    getAPI(APIRequestType.GET_TURBINE);
  }, []);

  useEffect(() => {
    if (!turbineTuL) return;

    setCameraStreamUrlTuL(null);
    setStreamStateTuL("LOADING");

    console.log("selectedCameraTuL orientation:", selectedCameraTuL);
    getAPI(APIRequestType.GET_CAMERA_STREAM);

    if (buttonColumnRef.current) {
      setButtonColumnHeight(buttonColumnRef.current.offsetHeight);
    }
  }, [selectedCameraTuL, turbineTuL]);

  useEffect(() => {
    console.log(" cameraStreamUrlTuL : ", cameraStreamUrlTuL);
    if (!cameraStreamUrlTuL || !videoRef.current) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(cameraStreamUrlTuL);
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoRef.current.play().catch(e => console.error('Video play error:', e));
      });

      return () => hls.destroy();
    }
  }, [cameraStreamUrlTuL]);

  useEffect(() => {
    console.log(" streamStateTuL : ", streamStateTuL);
  }, [streamStateTuL]);

  const handleCameraClick = (cameraNum) => {
    setSelectedCameraTuL(cameraNum);
  };

  const handleRefreshStream = () => {
    setCameraStreamUrlTuL(null); // on vide l'URL actuelle
    setStreamStateTuL("LOADING"); // on remet l'état en chargement
    getAPI(APIRequestType.GET_CAMERA_STREAM); // on relance l'appel API
  };


  return (
    <TurbineDashboardLayout>
      <TurbineDashboardNavbar />
      <MDBox display="flex" height="calc(100vh - 64px)" px={2} py={2} gap={6}>
        {/* Colonne gauche avec boutons de sélection caméra */}
        <MDBox
          ref={buttonColumnRef}
          display="flex"
          flexDirection="column"
          width="140px"
          gap={1}
        >
          {[...Array(8)].map((_, i) => {
            const cameraNum = i + 1;
            const isSelected = selectedCameraTuL === cameraNum;

            return (
              <MDBox key={cameraNum} display="flex" alignItems="center" gap={1}>
                <MDButton
                  variant="outlined"
                  color={isSelected ? "info" : "dark"}
                  size="small"
                  onClick={() => handleCameraClick(cameraNum)}
                  sx={{ height: "35px", fontSize: "0.75rem", paddingTop: "8px", minWidth: "120px" }}
                >
                  Camera {cameraNum}
                </MDButton>

                {isSelected && (
                  <MDButton
                    variant="contained"
                    color="info"
                    size="small"
                    onClick={(e) => {
                      handleRefreshStream();
                      e.currentTarget.blur(); // <-- enlève le focus après le clic
                    }}
                    sx={{ height: "30px", minWidth: "30px", padding: 0 }}
                    disabled={streamStateTuL === "LOADING"} // <-- Désactive si en cours de chargement
                  >
                    <RefreshIcon sx={{ width: "20px", height: "20px" }} />
                  </MDButton>
                )}
              </MDBox>
            );
          })}
        </MDBox>

        {/* Colonne droite avec player vidéo ou état du flux */}
        <MDBox
          flex={1}
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          sx={{
            height: `${buttonColumnHeight - buttonColumnHeight / 10}px`,
            position: "relative",
          }}
        >
          {streamStateTuL === "LOADING" && (
            <MDBox display="flex" flexDirection="column" alignItems="center" gap={1} mt={15}>
              <CircularProgress color="info" />
              <MDTypography variant="button"
                fontWeight="bold"
                color="dark"
                ml={1}
                fontSize="1rem">
                Waiting for connection...
              </MDTypography>
            </MDBox>
          )}

          {streamStateTuL === "NOT FOUND" && (
            <MDBox display="flex" flexDirection="column" alignItems="center" gap={1} mt={15}>
              <MDTypography variant="button"
                fontWeight="bold"
                color="secondary"
                opacity={0.4}
                ml={1}
                fontSize="3rem">
                Unable to establish a connection.
              </MDTypography>
            </MDBox>
          )}

          {streamStateTuL === "FOUND" && cameraStreamUrlTuL && (
            <video
              ref={videoRef}
              id="videoElement"
              controls
              autoPlay
              muted
              style={{
                borderRadius: "12px",
                backgroundColor: "#000",
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </MDBox>
      </MDBox>
    </TurbineDashboardLayout>
  );
}

export default TurbineLiveCameraView;
